/**
 * @generated SignedSource<<a46bc0b2c7a7aab1038aced2ab0135f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutRegistrationForm_buyer$data = {
  readonly authMetadata: {
    readonly hasPassword: boolean | null;
  } | null;
  readonly " $fragmentType": "CheckoutRegistrationForm_buyer";
};
export type CheckoutRegistrationForm_buyer$key = {
  readonly " $data"?: CheckoutRegistrationForm_buyer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationForm_buyer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutRegistrationForm_buyer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "kind": "LinkedField",
      "name": "authMetadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPassword",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "12a8c8331bed3a19c6052123d41f8516";

export default node;
